import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AccountCreated.module.scss';
import { ReactComponent as LogoImage } from '../../../images/logo-full.svg';
import accountImage from '../../../images/create-account.png';
import { resendVerificationEmail } from '../../../services/api';
import { AuthContext } from '../../../components/auth/AuthContext';
import { LoadingContext } from '../../../contexts/LoadingContext';
import { handleError } from '../../../utils/errorUtils';
import { showSuccessToastFullScreen } from '../../../utils/toastUtils';
import AuthFooter from '../../../components/auth/AuthFooter';

const AccountCreated: React.FC = () => {
  const navigate = useNavigate();
  const { userId: userIdFromContext } = useContext(AuthContext);
  const { setIsLoading } = useContext(LoadingContext);
  const [isResendingEmail, setIsResendingEmail] = useState(false);

  const getUserId = (): string | null => {
    const userIdFromStorage = localStorage.getItem('userId');
    return userIdFromContext || userIdFromStorage;
  };

  const handleResendEmailClick = async () => {
    const accessToken = localStorage.getItem('appAccessToken');
    const userId = getUserId();

    if (userId && accessToken) {
      try {
        setIsLoading(true);
        setIsResendingEmail(true);
        await resendVerificationEmail(userId, accessToken);
        console.info('Verification email resent successfully');
        showSuccessToastFullScreen('Verification email resent successfully.');
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
        setIsResendingEmail(false);
      }
    } else {
      console.error('User ID or access token not found');
      navigate('/signin');
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <a href="https://jobbeast.org" target="_blank" rel="noopener noreferrer">
          <LogoImage className={styles.logo} />
        </a>
      </div>
      <div className={styles.messageContainer}>
        <h1>We're almost there!</h1>
        <p>
          Please validate your account by clicking on the validation link that
          was sent to your email.
        </p>
        <p>If you did not receive a verification email, check your Spam folder.</p>
        <button
          type="button"
          onClick={handleResendEmailClick}
          disabled={isResendingEmail}
        >
          {isResendingEmail ? 'Resending...' : 'Resend Email'}
        </button>
      </div>
      <div className={styles.imageContainer}>
        <img src={accountImage} alt="Person sitting with a laptop" />
        <AuthFooter />
      </div>
    </div>
  );
};

export default AccountCreated;